module.exports = __webpack_public_path__ + "html/support.component.html";